import { useEffect, useSyncExternalStore } from 'react';
import { getEngine } from './appEngine';
import type { AppState } from './syncEngine';

// The app's data, as the sync engine currently has it.
export function useAppState(): AppState {
    const engine = getEngine();
    return useSyncExternalStore(engine.subscribe, engine.getState);
}

// Runs the sync engine for as long as the component is mounted (use once, at the root).
export function useRunSyncEngine(): void {
    useEffect(() => {
        const engine = getEngine();
        engine.start();
        return () => engine.stop();
    }, []);
}
